package com.example.mystybag.login.views

import androidx.compose.foundation.Image
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextDecoration
import com.arkivanov.decompose.extensions.compose.subscribeAsState
import com.example.mystybag.common.resources.SR
import com.example.mystybag.common.ui.components.native.DefaultButton
import com.example.mystybag.common.ui.components.native.Texts
import com.example.mystybag.common.ui.views.UIView
import com.example.mystybag.core.resources.SRC
import com.example.mystybag.core.ui.theme.LocalTheme.p16
import com.example.mystybag.core.ui.theme.LocalTheme.p24
import com.example.mystybag.core.ui.theme.LocalTheme.p40
import com.example.mystybag.core.ui.theme.LocalTheme.p56
import com.example.mystybag.core.ui.theme.LocalTheme.p64
import com.example.mystybag.core.ui.theme.LocalTheme.p76
import com.example.mystybag.core.ui.theme.LocalTheme.p8
import com.example.mystybag.login.logic.StaffBiometricViewModel
import dev.icerock.moko.resources.compose.painterResource
import dev.icerock.moko.resources.compose.stringResource
import com.example.mystybag.core.views.AppTheme

@Composable
fun StaffBiometricView(viewModel: StaffBiometricViewModel) {
    val uiState = viewModel.uiState.subscribeAsState()

    UIView(
        viewModel = viewModel,
        horizontalAlignment = Alignment.Start,
        showTopBar = false,
        removeVerticalPadding = true
    ) {
        if (uiState.value.showEnableScreen) {
            Column(
                modifier = Modifier
                    .fillMaxSize()
                    .padding(start = p16, end = p16, bottom = p16),
                horizontalAlignment = Alignment.Start
            ) {
                Spacer(modifier = Modifier.height(p76))
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    verticalAlignment = Alignment.Top,
                    horizontalArrangement = Arrangement.Start
                ) {
                    Image(
                        painter = painterResource(SRC.images.biometric_lock_icon),
                        contentDescription = null,
                        modifier = Modifier.size(p64)
                    )
                }
                Spacer(modifier = Modifier.height(p40))
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    verticalAlignment = Alignment.Top,
                    horizontalArrangement = Arrangement.Start
                ) {
                    Column(
                        modifier = Modifier.weight(1f),
                        horizontalAlignment = Alignment.Start,
                        verticalArrangement = Arrangement.spacedBy(p24)
                    ) {
                        Texts.DisplaySmall(
                            text = stringResource(SR.strings.login_securely_and_faster),
                            color = AppTheme.current.colors.onSurface,
                            textAlign = TextAlign.Start,
                            modifier = Modifier.fillMaxWidth()
                        )
                        Texts.BodyLarge(
                            text = stringResource(SR.strings.enable_biometric_description),
                            color = AppTheme.current.colors.onSurfaceVariant,
                            textAlign = TextAlign.Start,
                            modifier = Modifier.fillMaxWidth()
                        )
                    }
                }
                Spacer(modifier = Modifier.weight(1f))
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(bottom = p8),
                    horizontalAlignment = Alignment.CenterHorizontally,
                    verticalArrangement = Arrangement.spacedBy(p24)
                ) {
                    Texts.BodyLarge(
                        text = stringResource(SR.strings.skip_for_now),
                        color = AppTheme.current.colors.onSurfaceVariant,
                        textDecoration = TextDecoration.Underline,
                        textAlign = TextAlign.Center,
                        modifier = Modifier.clickable(onClick = { viewModel.onSkipBiometric() })
                    )
                    DefaultButton(
                        caption = stringResource(SR.strings.set_up),
                        callback = { viewModel.onSetUpBiometric() },
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(p56)
                    )
                }
            }
        } else {
            Box(modifier = Modifier.fillMaxSize())
        }
    }
}
